export default {
	state: {
		avatar: {}
	},
	getters: {
		"avatar": state => state.avatar
	},
	mutations: {
		setAvatar(state, payload) {
			state.avatar = payload
		}
	},
	actions: {
		atualizarEstadoAvatar({ commit }, payload) {
			commit('setAvatar', payload)
		}
	}
};